import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading placeholder for the conversation view while the resume flow resolves
 * which thread to open (`messages-thread` in its `pendingLatest` state). Drill-
 * in chrome is already up (header + back), so this fills the body with a few
 * ghost bubbles — the visitor lands in a conversation immediately instead of
 * seeing the thread list flash by before the jump.
 */
export function ConversationSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-col gap-4 px-4 py-5" aria-hidden="true">
      <div className="flex items-end gap-2">
        <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
        <Skeleton className="h-9 w-1/2 rounded-wx-lg" />
      </div>
      <div className="flex items-end gap-2">
        <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
        <Skeleton className="h-16 w-3/4 rounded-wx-lg" />
      </div>
      <div className="flex justify-end">
        <Skeleton className="h-9 w-2/5 rounded-wx-lg" />
      </div>
      <div className="flex items-end gap-2">
        <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
        <Skeleton className="h-11 w-2/3 rounded-wx-lg" />
      </div>
    </div>
  );
}
